import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';
import Select from 'react-select';


import {
statisticsAction,
statisticsCloseAction
} from '../../../actions/settingsAction';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const Add_department = (props) => {
const sparkline1 = React.createRef();
const sparkline2 = React.createRef();
const sparkline3 = React.createRef();
const sparkline4 = React.createRef();
 const [formData, setFormData] = useState({
		department_name: '',
		dept_head: '',
		
		});

const handleStatistics = (e) => {
	statisticsAction(e)
}
const closeStatistics = (e) => {
	statisticsCloseAction(e)
}

const { fixNavbar, statisticsOpen, statisticsClose } = props;


const [user, setUser] = useState({
	department_name: "",
	dept_head: null,
	
})

const [setform, setForm] = useState([]);
		const [settype, setType] = useState([]);
const history = useHistory();
const [data, setData] = useState([]);
const [setemp, setemployee] = useState([]);
const [isVisible, setIsVisible] = useState(false);
const [urlres, setUrlRes] = useState(false);
const [style1, setStyle1] = useState(false);
const [menu_type,setMenutype]=useState("");
const [loading, setLoading] = useState(false);
const [error, setError] = useState(null);
const [setcount, setCount] = useState([]);
const [table, setTable] = useState([]);
const handelInput = (event) => {
	event.preventDefault();
	const { name, value } = event.target;
	console.log(name, value)
	setUser({ ...user, [name]: value });

	
}



const handleChange = (e) => {
  
    const { name, value } = e.target;
    setFormData({
    ...formData,
    [name]: value,
    });
    };



	const emptymenu={
		department_name: "",
		dept_head: "",
		
	}

const handelMenutype = (event) => {

	setMenutype(event.target.value);

	// if (event.target.value === '1') {
	// 	setIsVisible(true);
	// } else {
	// 	setIsVisible(false);
	// }
}



		
const [searchTerm, setSearchTerm] = useState("");
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage, setItemsPerPage] = useState(10);
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
let filteredItems = data.filter((item) =>
	`${item.name.toLowerCase()}${item.department_name.toLowerCase()}`.includes(searchTerm.toLowerCase())

);
const filteredData = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
const startIndex = (currentPage - 1) * itemsPerPage;

useEffect(() => {
	setCurrentPage(1);
}, [searchTerm]);

const paginate = (pageNumber) => setCurrentPage(pageNumber);

const handleSearch = (event) => {
	//console.log(event.target.value);
	setSearchTerm(event.target.value);
};

const handleRowsPerPageChange = (e) => {
	setItemsPerPage(Number(e.target.value));
	setCurrentPage(1); // Reset to first page
};

const divStyle = {
	
	padding: '6px',
	borderRadius: '5px',
	};






		useEffect(() => {

		axios
		.get(API_BASE_URL+'/department_list', {
		headers: 
		{ 
		Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
		}
		})
		.then((response) => {
		console.log(response.data.data);
		setTable(response.data.data.leave_type);
		setData(response.data.data.leave_type);


		setLoading(false);
		})
		.catch((error) => {
		setError(error.message);
		setLoading(false);
		});
		}, []);



		useEffect(() => {

		axios
		.get(API_BASE_URL+'/all_employees', {
		headers: 
		{ 
		Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
		}
		})
		.then((response) => {

		console.log(response.data.data);
		setemployee(response.data.data.all_employee);


		setLoading(false);
		})
		.catch((error) => {
		setError(error.message);
		setLoading(false);
		});
		}, []);


		useEffect(() => {
				handleUpdate();
			}, []);


		const handleUpdate = async (department_id) => {

		axios.get(API_BASE_URL + '/showdepartment/' + department_id, {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		.then(res1 => setUser(res1.data))
		.catch(err => console.log(err))
		};



			const handleSubmit = async (e) => {

			e.preventDefault();
			// setError(null);
			// setLoading(true);
			//  e.preventDefault();


			//console.log(user.menu_icon);
			axios.post(API_BASE_URL+'/add_department' ,formData, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
			}).then(response => {
			// 	console.log(response.data);
			// 	console.log(response.data.message);
			// })

			var status = response.data.status;
			if (status=='success')
			{
			toast.success(response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});
			setTimeout(() => {
			window.location.reload(); // Reload the page after delay
			}, 3000);

			} 
			else if (status=='error')
			{
			toast.error(response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});
			// setTimeout(() => {
			//   window.location.reload(); // Reload the page after delay
			// }, 3000);

			}
			}).catch(error => {

			// console.log(error);
			// console.log(error.response.data.message);
			toast.error(error.response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});
			});
			}


	




			const handleEditSubmit = (e) => {

			// console.log('hi');


			e.preventDefault();

			// console.log(user);
			// setError(null);
			// setLoading(true);
			// e.preventDefault();
			console.log(user);

				axios.post(API_BASE_URL + '/updatedepartment', { department_name: user.department_name, department_id: user.department_id, dept_head:user.dept_head }, {

			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
			}).then(response => {


			var status = response.data.status;

			if (status=='success')
			{
			toast.success(response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});
			setTimeout(() => {
			window.location.reload(); // Reload the page after delay
			}, 3000);

			} 
			else if (status=='error')
			{
			toast.error(response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});
			// setTimeout(() => {
			//   window.location.reload(); // Reload the page after delay
			// }, 3000);

			}
			}).catch(error => {

			// console.log(error);
			// console.log(error.response.data.message);
			toast.error(error.response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});

			});
			};





			const options = [
				{ value: '1', label: 'Chocolate' },
				{ value: '2', label: 'Strawberry' },
				{ value: '3', label: 'Vanilla' },
			  ];


			  const handleSelectChange =(sp)=>{
				setFormData({
					...formData,
					['dept_head']: sp.value,
					});
console.log(formData.dept_head)
			  }

return (
	<>
		<div>
			<div>
<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
<div className="container-fluid">

<ToastContainer />


</div>
</div>


				<div className="section-body mt-3">
				<div className="container-fluid">
				<div className="row clearfix">
				<div className="col-md-12">
				<div className="card">
				<div className="card-header">
				<h3 className="card-title">Add Department</h3>
				</div>
				<div className="card-body">
				<form onSubmit={handleSubmit}>

				<div class="row">

				<div className="col-md-3 col-sm-6">
				<div className="form-group">
				<input type="text" className="form-control" name="department_name" value={formData.department_name} onChange={handleChange}
				placeholder="Department Name" />
				</div>
				</div>

				{/* <div className="col-md-2 col-sm-6">
				<select  className="form-control custom-select" id="dept_head"   name='dept_head'   value={formData.dept_head} onChange={handleChange}>
				<option value="" disabled>Select Emp</option>
				{setemp.map(option => (
				<option key={option.user_id} value={option.user_id}>
				{option.lable} {option.last_name}  ({option.value})

				</option>
				))}


				</select>

				</div> */}

				<div className="col-md-4 col-sm-6">
				<Select
        defaultValue={formData.dept_head}
		// name="dept_head"
        onChange={handleSelectChange} placeholder='Select Employee Name'
        options={setemp}
      />
	  </div>






				<div className="col-md-2 col-sm-6">
				<div className="form-group">

				<button type="submit" style={divStyle} className="btn btn-primary">
				+ Add
				</button>

				</div>
				</div>

				</div>











				</form>
				</div>
				</div>
				</div>

				</div>
				</div>
				</div>




				<div className="section-body">
				<div className="container-fluid">
				<div className="tab-content">
				<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
				<div className="card">
				<div className="card-header">
				<h3 className="card-title" style={{ color: '#e96827' }}>Department List</h3>
				<div className="card-options">
				<form>
				<div className="input-group">
				<select style={{
				padding: '8px',
				marginRight: '20px',
				borderRadius: '4px',
				border: '1px solid #ccc',
				backgroundColor: '#BCD1DB', display: 'flex', justifyContent: 'left'
				}}
				id="rowsPerPage"
				value={itemsPerPage}
				onChange={handleRowsPerPageChange}
				>
				<option value={10}>10</option>
				<option value={25}>25</option>
				<option value={50}>50</option>
				<option value={100}>100</option>
				</select>

				<input
				type="text"
				className="form-control form-control-sm"
				placeholder="Search"
				value={searchTerm}
				onChange={handleSearch} style={{ padding: '8px', width: '200px', borderRadius: '4px', border: '1px solid #ccc' }}
				/>
				</div>
				</form>
				</div>
				</div>

				{/* <div>
				<DataTable 
				columns={column} 
				data={data}
				customStyles={customStyles}
				pagination 
				highlightOnHover
				responsive
				paginationPerPage={10}
				paginationRowsPerPageOptions={[25,50,100,500]}
				className="table table-striped table-bordered"> 
				</DataTable>
				</div> */}



				<div className="card-body">
				<div className="table-responsive">
				<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
				<thead>
				<tr>
				<th>S.No</th>
				<th>Department Name</th>
				<th>Department Head </th>
				<th>Count</th>
				<th>Action</th>
				</tr>
				</thead>
				<tbody>
				{
				filteredData.map((table, index) => {



				return <tr key={index}>
				<td className="d-flex">
				<span style={table.department_id == '1' ? { "color": "black" } : { "color": "black" }}
				className="avatar avatar-blue"
				data-toggle="tooltip"
				data-original-title="Avatar Name"
				>
				{index + 1}
				</span>

				</td>
				<td>
				<span>{table.department_name}</span>
				</td>


				<td>
				<span>{table.name}</span>
				</td>
				<td>
				<span>{table.count}</span>
				</td>




				<td>



				<button
				type="button" onClick={() =>{ handleUpdate(table.department_id);setUser(emptymenu)}}
				className="btn btn-icon btn-sm"
				title="Edit" data-toggle="modal"
				data-target="#exampleEditModal"
				>
				<i className="fa fa-edit" />

				</button>




				{/* <Link to={`/hr-submenu?id=${table.department_id}`}>
				{table.department_id == '2' ? <i className="fa fa-eye" /> : ''}
				</Link> */}


				</td>
				</tr>
				})
				}

				</tbody>
				</table>
				</div>

				<nav aria-label="Page navigation">
				<ul className="pagination mb-0 justify-content-end">
				<li className="page-item"><button className="page-link"
				key={'f'}
				onClick={() => paginate(1)}
				>
				First
				</button></li>

				{Array.from(
				{ length: Math.ceil(filteredItems.length / itemsPerPage) },
				(_, index) => (
				<li className="page-item">
				<button className="page-link"
				key={index + 1}
				onClick={() => paginate(index + 1)}
				>
				{index + 1}
				</button></li>
				)
				)}

				<li className="page-item">
				<button className="page-link"
				key={'l'}
				onClick={() => paginate(Math.ceil(filteredItems.length / itemsPerPage))}
				>
				Last
				</button></li>

				</ul>
				</nav>


				</div>
				</div>
				</div>


				</div>
				</div>
				</div>

			</div>
		</div>


					<div
					className="modal fade"
					id="exampleEditModal"
					tabIndex={-1}
					role="dialog"
					aria-labelledby="exampleModalLabel"
					aria-hidden="true"
					>
					<form onSubmit={handleEditSubmit}>
					<div className="modal-dialog" role="document">
					<div className="modal-content">
					<div className="modal-header">
					<h5 className="modal-title" id="exampleModalLabel">
					Edit Department
					</h5>
					<button type="button" className="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">×</span>
					</button>
					</div>
					<div className="modal-body">
					<div className="row clearfix">

					<div className="col-md-12 col-sm-12">
					<div className="form-group">
					<input type="text" className="form-control"  id="department_name" name="department_name" 
					onChange={handelInput} placeholder="Department Name"  value={user.department_name}/>

					<input name="department_id" id="department_id" value={user.department_id} type="hidden" />

					</div>
					</div>

					{ <div className="col-md-12 col-sm-12">
					<select  className="form-control custom-select" id="dept_head"   name='dept_head'   value={user.dept_head} onChange={handelInput}>
					<option value="" disabled>Select Emp</option>
					{setemp.map(option => (
					<option key={option.lable} value={option.value}>
					{option.label}

					</option>
					))}


					</select>

					</div> }
					{/* <div className="col-md-12 col-sm-12">
					<Select
        defaultValue={user.dept_head}
		name={user.dept_head}
        onChange={handleSelectChange}
        options={setemp}
		key={setemp}
		className="mt-1 block w-full"
classNamePrefix="select"
      />
	  </div> */}

					</div>
					</div>
					<div className="modal-footer">
					<button type="button" className="btn btn-secondary" onClick={() =>setUser(emptymenu)} data-dismiss="modal">
					Close
					</button>
					<button type="submit" className="btn btn-primary">
					Save changes
					</button>
					</div>
					</div>
					</div>

					</form>

					</div>








	</>
);
}

const mapStateToProps = (state) => ({
fixNavbar: state.settings.isFixNavbar,
statisticsOpen: state.settings.isStatistics,
statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
statisticsAction: (e) => dispatch(statisticsAction(e)),
statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(Add_department);